import { ErrorHandler, HostListener, Injectable } from '@angular/core';
import { ErrorInterface } from '../models/error.interface';
import { ErrorService } from './error.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
  constructor(private errorService: ErrorService) {
    super();
  }

  @HostListener('window:unhandledrejection', [])
  public unhandledRejection(event: unknown) {
    this.handleError(event, true);
  }

  public override handleError(errorEvent: any, unhandled = false): void {
    const label = `ErrorHandlerService.handleError(${unhandled ? 'unhandled' : ''})`;

    // Do not spread `errorEvent`: on real Error instances `message`/`stack` are
    // non-enumerable, so spreading strips them and Sentry only sees the label.
    // Pass the original error through unchanged so the stacktrace is preserved.
    this.errorService.add({
      label,
      message: errorEvent?.message,
      error: errorEvent,
    } as ErrorInterface);
  }
}
